export default "__VITE_ASSET__8b8a24d6__"